import { Injectable } from '@angular/core';

import { EMPTY, from, of, switchMap } from 'rxjs';

import { Address, Geofence } from '@shared/restaurant/models';
import { calculateDistance } from '@shared/geo';

@Injectable({providedIn: 'root'})
export class GeolocationService {
  check(geofence: Geofence, address: Address, source: 'checkin' | 'waitlist' | 'reservation') {
    if (!(geofence?.enabled && geofence[source])) {
      return of(EMPTY);
    }

    return from(this.getGeolocation())
      .pipe(
        switchMap(position => {
          const distance = calculateDistance(
            {lat: address.lat, lng: address.lng},
            {lat: position.coords.latitude, lng: position.coords.longitude},
          );

          if (distance > geofence.distance) {
            throw new Error(geofence.message.replace('{distance}', String(geofence.distance)));
          }

          return of(EMPTY);
        }),
      );
  }

  private getGeolocation(): Promise<GeolocationPosition> {
    return new Promise<GeolocationPosition>((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        reject(new Error('Geolocation is not available'));

        return;
      }

      navigator.geolocation.getCurrentPosition(resolve, reject);
    })
      .catch(error => {
        if (error instanceof GeolocationPositionError) {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              throw new Error('Sorry, you must allow access to location data to access this page.');

            default:
              throw error;
          }
        }

        throw error;
      });
  }
}
